import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const LessonIssueApiUtils = {
  report(lessonId, type, comment) {
    return xhr(
      ApiConstants.CreateLessonIssue + lessonId.toString() + '/issues/',
      {
        method: 'post',
        body: JSON.stringify({
          type,
          comment: comment,
        }),
      },
    );
  },

  resolve(lessonId, action, reason, comment) {
    return xhr(
      ApiConstants.ResolveLessonIssue + lessonId.toString() + '/issue/resolve',
      {
        method: 'put',
        body: JSON.stringify({
          resolveAction: action,
          reason: reason,
          comment,
        }),
      },
    );
  },

  reportAndResolve(lessonId, issueType, action, reason, comment) {
    return xhr(
      ApiConstants.CreateLessonIssue +
        lessonId.toString() +
        '/issues/create-and-resolve',
      {
        method: 'post',
        body: JSON.stringify({
          issueType,
          resolveAction: action,
          reason,
          comment: comment,
        }),
      },
    );
  },

  fetchOne(lessonId) {
    return xhr(ApiConstants.FetchLessonIssue + lessonId.toString() + '/issue/');
  },
};

export default LessonIssueApiUtils;
